import axios from 'axios';
import { aadConfig, getAccessToken } from '../aad';
import apiProxy from './apiProxy';

/** One account setting: a value held under a group and a name. */
export type Setting = {
  groupName: string;
  propertyName: string;
  propertyValue?: string;
};

/** Every setting in a group, for the account. */
export const getSettingsGroup = apiProxy(
  'getSettingsGroup',
  async (accountId: string, group: string): Promise<Setting[]> => {
    await getAccessToken(aadConfig().accountScopes);
    const { data } = await axios.get(`${process.env.ACCOUNT_API}/settings/${accountId}/${group}`);
    return data ?? [];
  },
);

/** One setting, or undefined when it has never been set. */
export const getSetting = apiProxy(
  'getSetting',
  async (accountId: string, group: string, name: string): Promise<Setting | undefined> => {
    await getAccessToken(aadConfig().accountScopes);
    try {
      const { data } = await axios.get(
        `${process.env.ACCOUNT_API}/settings/${accountId}/${group}/${encodeURIComponent(name)}`,
      );
      return data ?? undefined;
    } catch {
      // Not set is a normal answer here, not a failure.
      return undefined;
    }
  },
);

/** Writes one setting, creating it if it does not exist. */
export const upsertSetting = apiProxy(
  'upsertSetting',
  async (accountId: string, setting: Setting): Promise<Setting> => {
    await getAccessToken(aadConfig().accountScopes);
    const { data } = await axios.post(`${process.env.ACCOUNT_API}/settings/${accountId}`, setting);
    return data;
  },
);
